import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BRAND_NAME, SUPPORT_EMAIL } from '../api/config';
import { PageShell } from '../components/Layout';

function LegalSection({ title, children }) {
  return (
    <section className="mb-8">
      <h2 className="font-serif text-xl text-forest font-semibold mb-3">{title}</h2>
      <div className="text-sm text-ink/70 leading-relaxed space-y-2">{children}</div>
    </section>
  );
}

export default function PrivacyPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <PageShell>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 md:py-14">
        <h1 className="page-title">Privacy Policy</h1>
        <p className="text-sm text-ink/50 mt-2">Effective: April 2026</p>

        <div className="mt-10 bg-white border border-sand p-6 md:p-10">
          <LegalSection title="Overview">
            <p>
              {BRAND_NAME} (&quot;we&quot;) collects limited personal information when you search for property records
              or complete a purchase. This policy describes what we collect and how we use it.
            </p>
          </LegalSection>
          <LegalSection title="Information we collect">
            <ul className="list-disc pl-5 space-y-1">
              <li>Email and phone number when you proceed to payment</li>
              <li>Search parameters (district, taluka, village, property number)</li>
              <li>Technical data such as IP address and browser type</li>
            </ul>
          </LegalSection>
          <LegalSection title="Data sources">
            <p>
              Property records displayed on {BRAND_NAME} are derived from publicly available government registry data.
              We do not create or alter official records — we present them in a searchable format.
            </p>
          </LegalSection>
          <LegalSection title="How we use your data">
            <p>To deliver search results, process payments, generate reports, and improve our service.</p>
          </LegalSection>
          <LegalSection title="Contact">
            <p>{SUPPORT_EMAIL}</p>
          </LegalSection>
        </div>

        <Link to="/" className="btn-outline mt-8 inline-flex">← Home</Link>
      </div>
    </PageShell>
  );
}
